var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileLinesBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 0.5C0.671572 0.5 0 1.17157 0 2V14C0 14.8284 0.671573 15.5 1.5 15.5H10.5C11.3284 15.5 12 14.8284 12 14V2C12 1.17157 11.3284 0.5 10.5 0.5H1.5ZM1.5 2L10.5 2V14H1.5V2ZM3.75 4.25C3.33579 4.25 3 4.58579 3 5C3 5.41421 3.33579 5.75 3.75 5.75H5.25C5.66421 5.75 6 5.41421 6 5C6 4.58579 5.66421 4.25 5.25 4.25H3.75ZM3 8C3 7.58579 3.33579 7.25 3.75 7.25H6.75C7.16421 7.25 7.5 7.58579 7.5 8C7.5 8.41421 7.16421 8.75 6.75 8.75H3.75C3.33579 8.75 3 8.41421 3 8ZM3.75 10.25C3.33579 10.25 3 10.5858 3 11C3 11.4142 3.33579 11.75 3.75 11.75H8.25C8.66421 11.75 9 11.4142 9 11C9 10.5858 8.66421 10.25 8.25 10.25H3.75Z",
    fill: "#28245C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLinesBlue);
export default __webpack_public_path__ + "static/media/file-lines-blue.296a7fc80a028b9e6438cab440731ade.svg";
export { ForwardRef as ReactComponent };